<match-wrapper
    class="bot-management-match"
    id="bot-management-match-{{ matchIndex }}"
    label="{{ label }}"
    objectType="{{ objectType }}"
    fieldName="{{ fieldName }}"
    (onRemoveMatch)="removeMatch()"
>
    <div 
        class="bot-management-match"
        provideParentForm
    >
        <enum-radio-buttons
            noMarginTop
            enum="MatchOperation"
            name="match-operation-{{ matchIndex }}"
            id="match-operation-{{ matchIndex }}"
            [(ngModel)]="editable.config.match_operation"
            required
        >
        </enum-radio-buttons>
        <div
            class="bot-management-match__data-grid-margin-top"
        >
            <avi-data-grid
                [config]="classificationGridConfig"
                [rows]="editable.config.classifications.config"
                gridTitle="{{ l10nKeys.classificationsLabel | vtranslate : editable.config.classifications.count }}"
            >
                <avi-data-grid_actions>
                    <cds-button
                        id="add-classification"
                        size="sm"
                        (click)="editable.addClassification()"
                    >
                        {{ globalL10nKeys.addLabel | vtranslate }}
                    </cds-button>
                </avi-data-grid_actions>
            </avi-data-grid>
        </div>
        <ng-template
            #classificationTemplateRef
            let-row
            let-index="index"
        >
            <avi-enum-dropdown
                name="{{ 'classification-' + index }}"
                id="{{ 'classification-' + index }}"
                enum="BotClassificationTypes"
                [(ngModel)]="row.data.config.type"
                required
            ></avi-enum-dropdown>
        </ng-template>
        <ng-template
            #valueTemplateRef
            let-row
            let-index="index"
        >
            <avi-input-container noMarginTop>
                <input
                    *ngIf="row.config.type === botClassificationTypesHash.USER_DEFINED_BOT"
                    clrInput
                    name="{{ 'value-' + index }}"
                    id="{{ 'value-' + index }}"
                    placeholder="{{ globalL10nKeys.valuePlaceholder | vtranslate }}"
                    [(ngModel)]="row.config.user_defined_type"
                    type="text"
                />
            </avi-input-container>
        </ng-template>
    </div>
</match-wrapper>
